import React, { useState } from 'react'
import { IoIosArrowDropright } from 'react-icons/io';

const items = [
    {
      title: '📊 Overview',
      content: (
        <div>
          <p><strong>💰 Total Prize Pool:</strong> ₦1,200,000</p>
          <p><strong>🏆 Leaderboard-Based Rewards:</strong></p>
          <table className="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Reward (₦)</th>
                <th>Condition</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>1st</td><td>₦300,000</td><td>≥ 600 points</td></tr>
              <tr><td>2nd</td><td>₦200,000</td><td>≥ 600 points</td></tr>
              <tr><td>3rd</td><td>₦100,000</td><td>≥ 600 points</td></tr>
              <tr><td>4th–15th</td><td>₦50,000 each</td><td>After top 3 meet target</td></tr>
            </tbody>
          </table>
        </div>
      )
    },
    {
      title: '🔁 Referral Challenge Breakdown',
      content: (
        <div>
          <p>Each referred user can complete 5 tasks to earn you a total of 10 points:</p>
          <section className="table-responsive">
            <table className="table table-bordered table-sm table-striped">
                <thead>
                <tr>
                    <th>Task</th>
                    <th>Description</th>
                    <th>Points</th>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Task A – Registration</td>
                        <td>New user signs up</td>
                        <td className='text-nowrap'>2 Points</td>
                    </tr>
                    <tr>
                        <td>Task B – KYC Completion</td>
                        <td>Full KYC verification</td>
                        <td className='text-nowrap'>2 Points</td>
                    </tr>
                    <tr>
                        <td>Task C – Phone Verification</td>
                        <td>Phone number confirmation</td>
                        <td className='text-nowrap'>2 Points</td>
                    </tr>
                    <tr>
                        <td>Task D – Fund Wallet</td>
                        <td>Make a first deposit</td>
                        <td className='text-nowrap'>2 Points</td>
                    </tr>
                    <tr>
                        <td>Task E – Send Money</td>
                        <td>Transfer to another account</td>
                        <td className='text-nowrap'>2 Points</td>
                    </tr>
                </tbody>
            </table>
          </section>
          <p><strong>Total per referred user:</strong> 10 Points</p>
        </div>
      )
    },
    {
      title: '⏳ Reward Disbursement Condition & How It Works',
      content: (
        <div>
          <p><strong>🎉 Reward Condition:</strong> Rewards will only be distributed once the top 3 users accumulate at least 600 points and 60 referrals each.</p>
          <p><strong>⚙️ How It Works:</strong></p>
          <ul>
            <li><IoIosArrowDropright className='mb-1' /> Share your unique referral link or code.</li>
            <li><IoIosArrowDropright className='mb-1' /> Invite others to register and complete tasks.</li>
            <li><IoIosArrowDropright className='mb-1' /> Earn 10 points for every fully active referred user.</li>
            <li><IoIosArrowDropright className='mb-1' /> Climb the leaderboard as your points increase.</li>
            <li><IoIosArrowDropright className='mb-1' /> Once the top 3 hit the target, rewards unlock for top 15.</li>
          </ul>
        </div>
      )
    }
];
  

const ReferralDetails = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
    setOpenIndex(prevIndex => (prevIndex === index ? null : index));
  };
  return (
    <div className="container leaderboard-details">
        <div className="accordion" id="customAccordion">
            {items.map((item, index) => (
                <div className="accordion-item" key={index}>
                <h2 className="accordion-header">
                    <button
                    className={`accordion-button ${openIndex === index ? '' : 'collapsed'}`}
                    onClick={() => handleToggle(index)}
                    type="button"
                    >
                    {item.title}
                    </button>
                </h2>
                <div
                    className={`accordion-collapse collapse ${openIndex === index ? 'show' : ''}`}
                >
                    <div className="accordion-body">{item.content}</div>
                </div>
                </div>
            ))}
        </div>
    </div>
  )
}

export default ReferralDetails